<template>
  <div class="modal-overlay" @pointerdown="handleMouseDown" @pointerup="handleMouseUp">
    <div class="single-modal-container-small" @click.stop="" ref="modal">
      <div class="modal-body-edit-box-title">
        <h2>{{ $t('modify_device') }}</h2>
        <img src="@/assets/images/x_black.svg" @click.stop="isDeviceModalSimpleOpen = false"/>
      </div>
      <div class="modal-body-edit-box-content">
        <div class="modal-body-edit-box-content-main">
          <table>
            <tbody>
              <tr>
                <th>{{ $t('device') }} ID</th>
                <td><input v-model="deviceId" id="deviceId" placeholder="장치 ID를 입력하세요" required disabled /></td>
              </tr>
              <tr>
                <th>{{ $t('device') }} {{ $t('name') }}</th>
                <td><input v-model="deviceName" id="deviceName" placeholder="장치 이름을 입력하세요" required disabled /></td>
              </tr>
              <tr>
                <th>{{ $t('image') }}</th>
                <td><ImageUploadPreview style="height: 100px;"/></td>
              </tr>
              <!-- <tr>
                <th>{{ $t('group') }}</th>
                <td>
                  <select id="groupId" v-model="groupId">
                    <option v-for="group in group_list" :key="group.group_id" :value="group.group_id">
                      {{ group.group_name }}
                    </option>
                  </select>
                </td>
              </tr> -->
              <tr>
                <th>{{ $t('interval_time') }} ({{ $t('second') }})</th>
                <td><input v-model="intervalTime" id="intervalTime" placeholder="전송 주기를 입력하세요" required /></td>
              </tr>
            </tbody>
          </table>
          <div class="button-group">
            <button type="button" @click.stop="isDeviceModalSimpleOpen = false" class="cancel-button">{{ $t('cancel') }}</button>
            <button type="button" @click.stop="deleteDevice(deviceId)" class="delete-button">{{ $t('delete') }}</button>
            <button type="button" @click.stop="saveDevice()" class="action-button">{{ $t('submit') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { SERVER_REQUEST, GET_SERVER_REQUEST, imageUrl } from '../utils/ServerConnect';
import { showNotification } from '@/utils/Notification';
import { loadingStore } from '@/utils/LoadingStore';
import { selectedSingleDevice } from '@/utils/SearchDevice';
import { isDeviceModalSimpleOpen } from '@/utils/ModalUtility';
import ImageUploadPreview from '@/components/ImageUploadPreview.vue';
import { fetchDeviceImages, previewImage, previewImageFile } from '@/utils/ImageUtility';
import { loginedUserData } from '@/utils/GlobalUtility';

const deviceId = ref('');
const deviceName = ref('');
const groupId = ref('1');
const intervalTime = ref('');
const group_list = ref([]);

const modal = ref(null);
let isDragging = false;

// API를 통해 장치정보 받아오기
const fetchData = async () => {
  loadingStore.showLoading();

  group_list.value = await GET_SERVER_REQUEST('group');

  const ud = await loginedUserData();
  if (ud.user_account === 'user') group_list.value = group_list.value.filter(gl => gl.group_id === 1 || gl.group_id === 22);

  deviceId.value = selectedSingleDevice.value.device_id;
  deviceName.value = selectedSingleDevice.value.device_name;
  groupId.value = selectedSingleDevice.value.group_id;
  intervalTime.value = selectedSingleDevice.value.update_interval / 1000;

  loadingStore.hideLoading();
};

const saveDevice = async () => {
  if (!deviceId.value || !deviceName.value || !groupId.value || !intervalTime.value) {
    showNotification('Enter information.', 'warn', 'top-center');
    return;
  }

  let upload_image = previewImage.value;
  if (previewImage.value === new URL('../assets/images/person.svg', import.meta.url).href) {
    upload_image = null;
  } else if (upload_image === imageUrl() + selectedSingleDevice.value.device_image) {
    upload_image = previewImage.value;
  } else {
    upload_image = previewImageFile.value
  }

  const formData = new FormData();
  formData.append("device_id", deviceId.value);
  formData.append("device_name", deviceName.value);
  formData.append("device_image", upload_image);
  formData.append("group_id", groupId.value);
  formData.append("update_interval", intervalTime.value * 1000);

  loadingStore.showLoading();
  await SERVER_REQUEST('device', 'PUT', formData, false, null);
  fetchDeviceImages();  // 수정된 이미지 캐싱을 위함
  loadingStore.hideLoading();
}

const deleteDevice = async (id) => {
  const totalData = {
    device_id: id
  }
  const jsonData = JSON.stringify(totalData);

  loadingStore.showLoading();
  await SERVER_REQUEST('device', 'DELETE', jsonData);
  loadingStore.hideLoading();
  
  isDeviceModalSimpleOpen.value = false;
}

// Initialize map on component mount
onMounted(() => {
  fetchData();
  const setDeviceImage = selectedSingleDevice.value.device_image ? imageUrl() + selectedSingleDevice.value.device_image : new URL('../assets/images/person.svg', import.meta.url).href;
  previewImage.value = setDeviceImage;
  loadingStore.hideLoading();
});
onUnmounted(() => {
  previewImage.value = null;
})

const handleMouseDown = (event) => {
  if (modal.value.contains(event.target)) {
    isDragging = true; // 모달 내부에서 클릭 시작
  }
};

const handleMouseUp = (event) => {
  if (!modal.value.contains(event.target) && !isDragging) {
    isDeviceModalSimpleOpen.value = false; // 모달 외부에서 클릭 떼면 닫기
  }
  isDragging = false; // 드래그 상태 초기화
};
</script>

<style>
:disabled {
  background-color: lightgray;
}
</style>